import { render, staticRenderFns } from "./CustomersGeneralFilterClassicSegmentsCreate.vue?vue&type=template&id=83e1f572&"
import script from "./CustomersGeneralFilterClassicSegmentsCreate.vue?vue&type=script&lang=js&"
export * from "./CustomersGeneralFilterClassicSegmentsCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports